import { paths, supportEmail } from "@clockwise/client-commons/src/constants/site";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import * as React from "react";
import { ConstructionBlock } from "../../components/svgs/ConstructionBlock";
import { ExtensionURLs } from "../../constants/stores.constant";
import { colors, greys } from "../../styles/color.styles";
import { fontFamilyBrand } from "../../styles/type.styles";

export interface ExtensionDeprecatedStateProps {}

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 30,
  },
  bodyBase: {
    fontFamily: fontFamilyBrand,
    fontSize: `${14 / 16}rem`,
    lineHeight: 1.3,
    color: greys.darkestGrey,
    margin: "16px 0px 8px",
    textAlign: "center",

    "& > a": {
      color: colors.blueCool.standard,
      textDecoration: "underline",

      "&:hover": {
        cursor: "pointer",
      },
    },
  },
  url: {
    color: colors.green.darker,
    textDecoration: "none",
    margin: 0,

    "&:hover": {
      cursor: "pointer",
    },
  },
});

export const ExtensionDeprecatedState = ({}: ExtensionDeprecatedStateProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <ConstructionBlock />
      <p className={classes.bodyBase}>
        Clockwise is no longer supported as a Safari extension starting February 7th, 2022. You can
        continue using Clockwise in{" "}
        <a href={ExtensionURLs.chrome} target="_blank" rel="noreferrer">
          Chrome
        </a>{" "}
        or{" "}
        <a href={ExtensionURLs.firefox} target="_blank" rel="noreferrer">
          Firefox
        </a>{" "}
        or by visiting{" "}
        <a href={paths.webApp} target="_blank" rel="noreferrer">
          our app
        </a>{" "}
        in your Safari browser.
      </p>
      <a
        href={`mailto:${supportEmail}`}
        target="_blank"
        className={classnames(classes.bodyBase, classes.url)}
        rel="noreferrer"
      >
        Email support
      </a>
    </div>
  );
};
